import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../assets/images/logo/alba.png'
import _imports_1 from '../../assets/images/theme/loading.gif'


const _hoisted_1 = { class: "columns" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "friOpacity6 pe-3",
    width: "300"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center mt-3 fw-bold friColor4",
  style: {"font-size":"30px"}
}, "Aplicaciones", -1)
const _hoisted_5 = { class: "text-center mb-4 friColor4" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "form-head stuck-header",
  style: {"border":"0 !important"}
}
const _hoisted_8 = { class: "form-head-inner" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "py-2 fs-3" }, "Aplicaciones", -1)
const _hoisted_10 = {
  key: 0,
  class: "inline-block align-top me-2 fs-6 mt-0",
  style: {"margin-top":"4px"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "fs-5" }
const _hoisted_14 = { class: "text-xs3" }
const _hoisted_15 = {
  key: 0,
  class: "badge text-dark friBorder3"
}
const _hoisted_16 = {
  key: 1,
  class: "pt-5"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, "No ha creado ninguna aplicación.", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 1,
  class: "text-center mt-5 w-100"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"150px","margin-top":"80px"}
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-grid text-center friOpacity3 friColor4",
    style: {"font-size":"50px"}
  })
], -1)
const _hoisted_23 = {
  class: "text-center fw-bold text-dark friColor4",
  style: {"font-size":"25px"}
}
const _hoisted_24 = { class: "fs-6 fw-normal" }
const _hoisted_25 = { class: "mx-5 fs-3 text-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { htmlFor: "file" }, "Logotipo", -1)
const _hoisted_27 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "mt-5" }
const _hoisted_30 = { class: "d-flex justify-content-center" }
const _hoisted_31 = {
  key: 1,
  class: "text-center w-100",
  style: {"margin-top":"150px"}
}
const _hoisted_32 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 fs-5" }, "Creando", -1)
const _hoisted_35 = { class: "fs-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Espere por favor ...", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border friColor1 mt-5",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando ...")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_IonButton = _resolveComponent("IonButton")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(!_ctx.layout.loading ? 'account-wrapper text-left' : 'w-100')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["account-box is-form is-footerless", _ctx.isMobile ? 'mt-3' : 'mt-1']),
        style: _normalizeStyle([_ctx.isMobile ? 'border: none !important;' : 'border: none !important;', {"background-color":"transparent"}])
      }, [
        (_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _hoisted_3,
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  (_ctx.layout.apps && Object.keys(_ctx.layout.apps.apps).length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.layout.apps.active) + " activas de " + _toDisplayString(Object.keys(_ctx.layout.apps.apps).length), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                (_ctx.layout.apps &&  Object.keys(_ctx.layout.apps.apps).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.layout.apps.active) + " activos de " + _toDisplayString(Object.keys(_ctx.layout.apps.apps).length), 1))
                  : _createCommentVNode("", true)
              ])
            ])),
        _createElementVNode("div", {
          class: _normalizeClass(["form-body p-0 m-0 friBackWhite vh-100", _ctx.isMobile ? 'pt-0' : 'p-0'])
        }, [
          (!_ctx.layout.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_ctx.layout.apps && _ctx.layout.apps.apps && Object.keys(_ctx.layout.apps.apps).length)
                  ? (_openBlock(), _createBlock(_component_ion_list, {
                      key: 0,
                      style: {"background-color":"#fff !important"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.apps.apps, (app, appId) => {
                          return (_openBlock(), _createBlock(_component_ion_item, {
                            detail: "",
                            key: appId,
                            style: {"--ion-item-border-color":"#e4e3e3"},
                            onClick: ($event: any) => (_ctx.$router.push({ path: '/app/' + appId, query: { section:  'dashboard' } })),
                            class: "cursor-pointer mx-2 pe-4 ps-1"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_avatar, { slot: "start" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    src: app.logo,
                                    style: {"height":"40px"}
                                  }, null, 8, _hoisted_12)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_ion_label, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h2", _hoisted_13, _toDisplayString(app.name), 1),
                                  _createElementVNode("div", _hoisted_14, "ID: " + _toDisplayString(app.id), 1),
                                  (!app.active)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Inactivo"))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
        ], 2)
      ], 6)
    ]),
    _createVNode(_component_ion_modal, {
      "is-open": _ctx.$router.currentRoute.value.path == '/apps/add',
      "backdrop-dismiss": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/devices/'))),
                  class: "border-none"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cerrar")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_content, null, {
          default: _withCtx(() => [
            (!_ctx.layout.modalLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createTextVNode("Nueva Aplicación"),
                    _createElementVNode("div", _hoisted_24, [
                      _createTextVNode("AppId: "),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.layout.newApp.appId), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_ion_list, {
                      class: _normalizeClass(_ctx.isMobile ? '' : 'mx-5')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, {
                          lines: "full",
                          class: "border-none",
                          style: {"--ion-item-border-color":"#ccc"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              position: "floating",
                              class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Nombre")
                              ]),
                              _: 1
                            }, 8, ["class"]),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.layout.newApp.name,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.layout.newApp.name) = $event)),
                              type: "text",
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          lines: "full",
                          class: "border-none",
                          style: {"--ion-item-border-color":"#ccc"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              position: "floating",
                              class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Descripción")
                              ]),
                              _: 1
                            }, 8, ["class"]),
                            _createVNode(_component_ion_input, {
                              modelValue: _ctx.layout.newApp.description,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.layout.newApp.description) = $event)),
                              type: "text",
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_item, {
                          lines: "full",
                          class: "border-none",
                          style: {"--ion-item-border-color":"#ccc"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              position: "floating",
                              class: _normalizeClass(["friColor1", _ctx.isMobile ? 'fs-4' : ' fs-5'])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Cliente")
                              ]),
                              _: 1
                            }, 8, ["class"]),
                            _createVNode(_component_ion_select, {
                              interface: "popover",
                              modelValue: _ctx.layout.newApp.clientId,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.layout.newApp.clientId) = $event)),
                              class: "pfInputValue"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.clients?.clients, (client, clientId) => {
                                  return (_openBlock(), _createBlock(_component_ion_select_option, {
                                    key: clientId,
                                    value: clientId
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(client.first) + " " + _toDisplayString(client.last) + " (" + _toDisplayString(client.email) + ")", 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_IonButton, {
                          fill: "none",
                          class: "mt-5 px-0 mx-0"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("input", {
                              id: "file",
                              hidden: "",
                              type: "file",
                              accept: "image/*",
                              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.previewImage($event)))
                            }, null, 32),
                            _hoisted_26
                          ]),
                          _: 1
                        }),
                        (_ctx.layout.newApp.logo)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              _createElementVNode("img", {
                                src: _ctx.layout.newApp.logo,
                                alt: "",
                                width: "100",
                                height: "100"
                              }, null, 8, _hoisted_28)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("button", {
                        class: "button px-5 py-2 m-0 mt-0 bg-light",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/apps/')))
                      }, "Cancelar"),
                      _createElementVNode("button", {
                        class: "button px-5 py-2 ms-3 fw-bold friBack1 text-white outline-none",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addApp()))
                      }, "Crear")
                    ])
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  (_ctx.layout.newApp.logo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("img", {
                          src: _ctx.layout.newApp.logo,
                          alt: "",
                          width: "100",
                          height: "100"
                        }, null, 8, _hoisted_33)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_34,
                  _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.layout.newApp.name), 1),
                  _hoisted_36,
                  _hoisted_37
                ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 2))
}